module.exports = __webpack_public_path__ + "static/media/img-newtaipeicity-en-desktop.d958c281.svg";